import Axios from 'axios';
import {API_URL} from "../Constants";

const axios = Axios.create({
    baseURL: API_URL,
    headers: {
        Authorization: 'Bearer ' + localStorage.getItem("token")
    },
    withCredentials: true
});


axios.interceptors.request.use((config) => {
    return config;
})

axios.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.response.status === 403) {
            window.location.href = '/unauthorized';
        }
        if (error.response.status === 500) {
                window.location.href = '/login'
        }
        // if (error.response.status === 500 && error.response.data.message.startsWith('JWT expired')) {
        //     console.log("JWT");
        //     window.location.href = '/login'
        // }
        if (error.response.status === 409) {
            return error;
        }
    }
)

export default axios;